import { cookiePrivacyPolicyPopupStyles } from "@insite/content-library/Components/CookiePrivacyPolicyPopup";
import { breadcrumbStyles } from "@insite/content-library/Widgets/Basic/Breadcrumbs";
import { css } from "styled-components";

// Breadcrumbs
breadcrumbStyles.pageBreadcrumbs = {
    breadcrumbs: {
        css: css`
            flex-wrap: wrap;
            padding: 20px 0;
        `,
    },
};

// CookiePrivacyPolicyPopup
cookiePrivacyPolicyPopupStyles.drawer = {
        position: "bottom",
        size: 100,
        cssOverrides: {
            drawerTitle: css`
                display: none;
                background: white;
            `,
            drawerContent: css`
                padding: 30px 10% 30px 10%;
                margin: 0 auto;
                width: 100%;
                background: white;
            `,
        },
        closeButtonProps: {
            css: css`
                display: none;
            `,
        },
        enableClickThrough: true,
};

cookiePrivacyPolicyPopupStyles.messageText = {
    css:css`
            font-size: 13px;
        `,
};

